import Modal from 'molecules/Modal';
import React, { FC, useState } from 'react';
import {
  ModalActions,
  ModalCloseButton,
  ModalSubmitButton,
} from 'molecules/Modal/Modal.styles';
import { CaptchaModal } from 'molecules/CaptchaModal/CaptchaModal';
import { useTenant } from 'tenants/TenantProvider';

const CloudOpsProjectDeleteDialog: FC<{
  onClose: () => void;
  onDelete: () => void;
}> = ({ onClose, onDelete }) => {
  const { branding } = useTenant();
  const [open, setOpen] = useState<boolean>(true);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);

  const onShowCaptcha = () => {
    setOpen(false);
    setShowCaptcha(true);
  };

  return (
    <>
      <Modal
        open={open}
        maxWidth="sm"
        title="Delete the project"
        subtitle={`After project is deleted from ${branding.productName} it can be added again and assigned to any company in ${branding.productName}.`}
        transitionDuration={0}
        onClose={onClose}
      >
        <ModalActions>
          <ModalCloseButton autoFocus variant="outlined" onClick={onClose}>
            Cancel
          </ModalCloseButton>
          <ModalSubmitButton variant="contained" onClick={onShowCaptcha}>
            Delete
          </ModalSubmitButton>
        </ModalActions>
      </Modal>

      {showCaptcha ? (
        <CaptchaModal onComplete={onDelete} onClose={onClose} />
      ) : (
        <span />
      )}
    </>
  );
};

export default CloudOpsProjectDeleteDialog;
